// extracted by mini-css-extract-plugin
export default {"link":"SmsComposeAndSend_link__Eni-f"};